import { orangeMui } from "@ryde/theme";

import type { TLiveMapIncidentMarkerIconType } from "./live-map.incident-marker.models";

/** Visible marker pin (badge/dot) — keep in sync with `live-map.incidents-layer.styled.tsx`. */
export const LIVE_MAP_INCIDENT_MARKER_BOX_PX = 36;

/**
 * Leaflet `DivIcon` canvas — larger than the pin so opened glow / unopened rays are not clipped.
 */
export const LIVE_MAP_INCIDENT_ICON_CANVAS_PX = 73;

/** Radial halo diameter for opened incidents (px). */
export const LIVE_MAP_INCIDENT_OPENED_HALO_SIZE_PX = 56;

/** Extra Leaflet `Popup` offset so the card clears the badge. */
export const LIVE_MAP_INCIDENT_POPUP_EXTRA_OFFSET_Y = -6;

/** Typed badge scale pulse while the popup has never been opened (same as detour car). */
export const LIVE_MAP_INCIDENT_BADGE_UNOPENED_SCALE_MIN = 0.9;

/** Expanding rays while popup was never opened. */
export const INCIDENT_MARKER_PULSE_BORDER_ALPHA = 0.85;
export const INCIDENT_MARKER_PULSE_SHADOW_ALPHA = 0.72;

/** Extra drop-shadow on opened ring (radial halo is primary). */
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_BLUR_INNER_PX = 4;
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_BLUR_MID_PX = 12;
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_BLUR_OUTER_PX = 21;
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_ALPHA_INNER = 0.9;
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_ALPHA_MID = 0.55;
export const LIVE_MAP_INCIDENT_OPENED_RING_GLOW_ALPHA_OUTER = 0.28;
export const LIVE_MAP_INCIDENT_OPENED_HALO_ALPHA_CORE = 0.72;
export const LIVE_MAP_INCIDENT_OPENED_HALO_ALPHA_MID = 0.38;
export const LIVE_MAP_INCIDENT_OPENED_HALO_ALPHA_EDGE = 0.14;
export const LIVE_MAP_INCIDENT_OPENED_HALO_FADE_STOP_PERCENT = 64;

export const DEFAULT_ORANGE_MARKER_COLOR = orangeMui._600;

/** Original Figma badge fills (`red_lamp`, `wrestle`, `car_with_excl`, `way`). */
export const FIGMA_BADGE_FILL_BY_ICON_TYPE: Record<
  TLiveMapIncidentMarkerIconType,
  string
> = {
  security: "#FF005E",
  repair: "#B6041A",
  ride_event: "#FF8800",
  road_block: "#F66F44",
};

export const DEFAULT_COLOR_BY_ICON_TYPE: Record<
  TLiveMapIncidentMarkerIconType,
  string
> = FIGMA_BADGE_FILL_BY_ICON_TYPE;

export const ICON_TYPE_SET = new Set<string>(
  Object.keys(DEFAULT_COLOR_BY_ICON_TYPE),
);
